// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { DomainSourceSchema } from '../inputTypeSchemas/DomainSourceSchema'

/////////////////////////////////////////
// DOMAIN CONFIG SCHEMA
/////////////////////////////////////////

export const DomainConfigSchema = z.object({
  source: DomainSourceSchema.nullable(),
  domain: z.string(),
  isInFunctionalityScope: z.boolean().nullable(),
  isInTestingScope: z.boolean().nullable(),
  isThirdParty: z.boolean().nullable(),
  hasWaf: z.boolean().nullable(),
  createdAt: z.coerce.date(),
  enabledAt: z.coerce.date().nullable(),
})

export type DomainConfig = z.infer<typeof DomainConfigSchema>

export default DomainConfigSchema;
